<template>
  <div class="pie">
    <header>
      <h3>产品标签分布</h3>
      <span>(工单创建时间)</span>
    </header>
    <div ref="target" style="width: 100%; height: 300px"></div>
  </div>
</template>
<script>
import * as echarts from "echarts"
export default {
  props: {
    dataList: {
      type: Object,
      default: () => [],
    },
  },
  data() {
    return {
      myChart: null,
    }
  },

  mounted() {
    this.myChart = echarts.init(this.$refs.target)
    this.renderChart()
    window.addEventListener("resize", this.handleResize)
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize)
    this.myChart && this.myChart.dispose()
  },

  methods: {
    renderChart() {
      console.log(this.dataList, "ddd")

      // 创建echarts配置
      const options = {
        tooltip: {
          trigger: "item",
        },
        // legend: {
        //   type: "scroll",
        //   pageIconColor: "#76b9ff",
        //   pageIconInactiveColor: "#ccc",
        //   pageTextStyle: {
        //     color: "#76b9ff",
        //     fontSize: 14,
        //   },
        //   show: true,
        //   top: "4%",
        //   bottom: "1%",
        //   itemWidth: 10, // 图例标记的图形宽度。
        //   itemHeight: 10, //  图例标记的图形高度。
        //   textStyle: {
        //     color: "#ccc",
        //     fontSize: 12,
        //     padding: [0, 8, 0, 8],
        //   },
        // },
        series: [
          {
            name: "",
            type: "pie",
            selectedMode: "single",
            center: ["50%", "50%"],
            radius: [0, "45%"],
            label: {
              position: "inner",
              textStyle: {
                fontSize: 14,
                color: "#fff",
              },
            },
            data: this.dataList.app_type.map((item) => ({
              value: item.num,
              name: item.name,
            })),
          },
          {
            name: "",
            type: "pie",
            center: ["50%", "50%"],
            radius: ["55%", "70%"],
            avoidLabelOverlap: false,

            data: this.dataList.package_type.map((item) => ({
              value: item.num,
              name: item.name,
            })),
          },
        ],
      }

      // 设置图表配置
      this.myChart.setOption(options)

      // 添加点击事件，实现饼图联动
      // this.myChart.off("click")
      // this.myChart.on("click", (params) => {
      //   if (params.seriesName === "主分类") {
      //     // 查找被点击分类的子数据
      //     const selectedCategory = categoryData.find(
      //       (item) => item.name === params.name
      //     )
      //     if (selectedCategory && selectedCategory.children) {
      //       subData = selectedCategory.children
      //       this.myChart.setOption({
      //         series: [
      //           {
      //             name: "子分类",
      //             data: subData,
      //           },
      //         ],
      //       })
      //     }
      //   }
      // })
    },

    handleResize() {
      this.myChart && this.myChart.resize()
    },
  },
  watch: {
    dataList: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.myChart = echarts.init(this.$refs.target)
          this.renderChart()
          window.addEventListener("resize", this.handleResize)
        }
      },
      deep: true,
    },
  },
}
</script>

<style scoped lang="scss">
.pie {
  header {
    display: flex;
    align-items: center;
    span {
      color: #a9afb9;
      margin-left: 10px;
    }
  }
}
</style>
